"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import {
  ShopBreadcrumbsProvider,
  useShopBreadcrumbs,
} from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";
import {
  EcommerceTermsProvider,
  useEcommerceTerms,
} from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";


declare const wvcClient: any;

function ArchiveTitleContent() {
  const { links, loading: breadcrumbsLoading } = useShopBreadcrumbs();
  const { terms, loading: termsLoading } = useEcommerceTerms();

  
  const title = links.length > 0 ? links[links.length - 1].title : "Digital Services";

  
  const description = terms.length === 1 ? terms[0].description : null;

  return (
    <div className="container relative z-10 mx-auto px-4">
      <div className="flex flex-col items-center text-center space-y-6">
        {}
        <div className="min-h-[24px]">
          {!breadcrumbsLoading && links.length > 0 && (
            <Breadcrumb>
              <BreadcrumbList className="justify-center text-muted-foreground/80">
                {links.map((link, index) => {
                  const isLast = index === links.length - 1;
                  return (
                    <React.Fragment key={link.href}>
                      <BreadcrumbItem>
                        {isLast ? (
                          <BreadcrumbPage className="text-foreground font-medium">
                            {link.title}
                          </BreadcrumbPage>
                        ) : (
                          <BreadcrumbLink asChild>
                            <Link to={link.href} className="hover:text-primary transition-colors">
                              {link.title}
                            </Link>
                          </BreadcrumbLink>
                        )}
                      </BreadcrumbItem>
                      {!isLast && <BreadcrumbSeparator />}
                    </React.Fragment>
                  );
                })}
              </BreadcrumbList>
            </Breadcrumb>
          )}
        </div>

        {}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default tracking-tight text-foreground">
          {title}
        </h1>

        {}
        {!termsLoading && description && (
          <p className="max-w-2xl text-lg md:text-xl text-muted-foreground">
            {description}
          </p>
        )}
      </div>
    </div>
  );
}

export default function ArchiveTitleSection() {
  
  const current_wp_term_query_params = typeof wvcClient !== 'undefined' ? wvcClient.getCurrentWPTermQueryParams() : {};
  const wp_term_query = new WP_Term_Query(current_wp_term_query_params);

  return (
    <section
      id="archive-title-section"
      className="dark bg-background text-foreground relative py-16 md:py-24 overflow-hidden border-b border-border/10"
    >
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-background to-background pointer-events-none" aria-hidden="true" />
      
      <EcommerceTermsProvider wp_term_query={wp_term_query}>
        <ShopBreadcrumbsProvider>
          <ArchiveTitleContent />
        </ShopBreadcrumbsProvider>
      </EcommerceTermsProvider>
    </section>
  );
}